export const CONTACT_EMAIL_TEST_ID = "contact-email";
export const CONTACT_PHONE_TEST_ID = "contact-phone";
export const CONTACT_COUNTRY_CODE_TEST_ID = "country-code";
export const CONTACT_POLICY_CHECKBOX_TEST_ID = "contact-policy";
export const CONTACT_SUBMIT_BUTTON_TEST_ID = "contact-submit";
export const CONTACT_DETAILS_STEP = "contactdetails-stepform";
export const DATA_CHECKED = "data-checked";
